import { useEffect, useState } from "react";
import styles from "./index.module.scss";

import { MangopayUserStatusEnum } from "~/types/data/Company.types";
import { useCompanyAccountContext } from "~/context/companyAccountContext";
import CustomModal from "../CustomModal";
import { CustomButton } from "~/components/form/CustomButton";
import { colors } from "~/constants/styles";
import {
  ENROLL_SCA_GQL,
  EnrollForSCAInput,
  EnrollForSCAResponse,
} from "~/api/graphql/company";
import { useLazyQueryWithCallbacks } from "~/hooks/lazyQueryWithCallbacks";

type Props = {
  children: React.ReactNode;
};
export const ScaWrapper = ({ children }: Props) => {
  const { companyAccount } = useCompanyAccountContext();
  const [showPopup, setShowPopup] = useState<boolean>(false);

  useEffect(() => {
    if (!companyAccount || !companyAccount.mangopayId) return;
    setShowPopup(
      companyAccount?.mangopayUserStatus ===
        MangopayUserStatusEnum.PENDING_USER_ACTION
    );
  }, [companyAccount?.mangopayUserStatus]);

  const { trigger: enrollSca } = useLazyQueryWithCallbacks<
    EnrollForSCAResponse,
    EnrollForSCAInput
  >(
    ENROLL_SCA_GQL,
    (data) => {
      console.log("ScaWrapper data", data);
      window.location.href = data.enrollCompanyForSCA.scaUrl;
    },
    (error) => {
      console.log("ScaWrapper error", error);
    }
  );

  return (
    <>
      <CustomModal onCancel={() => {}} show={showPopup} removeCloseButton>
        <div className={styles.container}>
          <h3 className={styles.title}>
            Suite à une mise à jour des directives européennes sur les services
            de paiement, les utilisateurs doivent désormais activer
            l'authentification forte (SCA) afin d'améliorer la sécurité et la
            protection des utilisateurs.
          </h3>
          <div className={styles.buttonContainer}>
            <CustomButton
              onClick={() => {
                enrollSca({
                  variables: {
                    EnrollForSCAInput: {
                      redirectUrl: `${window.location.origin}/dashboard`,
                    },
                  },
                });
              }}
              backgroundColor={colors.$primary}
              color="white"
              width="fit-content"
              borderRadius="8px"
              padding="1rem 1.5rem"
            >
              Activer l'authentification forte (SCA)
            </CustomButton>
          </div>
        </div>
      </CustomModal>
      {children}
    </>
  );
};
